import Cloudbeds from './CloudBeds';
import Stripe from './Stripe';
import StripeSimple from './StripeSimplle';
import Paysafe from './Paysafe';
import Adyen from './Adyen';

export {
    Cloudbeds,
    Stripe,
    StripeSimple,
    Paysafe,
    Adyen,
};


